// extracted by mini-css-extract-plugin
module.exports = {"title":"ContactsOffices_title__xGPk7","offices":"ContactsOffices_offices__XnmAp"};